export default function AddParticipantIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <g clipPath='url(#clip0_70_6825)'>
        <path
          d='M15.8337 10.8334H10.8337V15.8334H9.16699V10.8334H4.16699V9.16669H9.16699V4.16669H10.8337V9.16669H15.8337V10.8334Z'
          fill='#316CF4'
        />
      </g>
      <defs>
        <clipPath id='clip0_70_6825'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
